import React from 'react';
import { Container, Section } from '../ui/Section';
import { ButtonLink } from '../ui/Button';
import { PhotoFrame } from '../ui/PhotoFrame';
import { ScriptEyebrow } from '../ui/ScriptEyebrow';
import { Reveal, stagger } from '../motion/Reveal';
import { FloatingPhoto } from '../motion/FloatingPhoto';
import { DoodleCircle, DoodleUnderline } from '../brand/Doodles';
import { galleryPhotos } from '../../data/photos';
const activities = [{
  title: 'Worship & Scripture',
  copy: 'Gather for worship, Bible study, and conversations centered on following Jesus.'
}, {
  title: 'Community & Friendship',
  copy: 'Build meaningful relationships through worship nights, community groups, shared meals, and time together.'
}, {
  title: 'Service & Outreach',
  copy: 'Serve others, reach students across campus, and help make UCF a place where people feel seen and welcomed.'
}, {
  title: 'Missions, Sports & More',
  copy: 'Take part in missions, intramural sports, recreational nights, retreats, and other opportunities throughout the year.'
}];
const accentBars = ['bg-brand-yellow', 'bg-brand-pink', 'bg-brand-blue', 'bg-brand-navy'];
export function WhoWeAre() {
  return <Section className="bcm-paper overflow-hidden py-16 sm:py-20" labelledBy="who-heading" data-id="element-269" data-mp="3e7ocl14nh2vu">
      <Container data-id="element-270" data-mp="3izo548ie4tie">
        <div className="grid items-start gap-10 lg:grid-cols-[1fr_0.85fr] lg:gap-14" data-id="element-271" data-mp="3j07o7sjs1ny0">
          <Reveal data-id="element-272" data-mp="3mzzq5meo0vue">
            <ScriptEyebrow data-id="element-273" data-mp="3n0hu757kkecv">Come as you are</ScriptEyebrow>
            <h2 id="who-heading" className="mt-3 font-serif text-3xl font-semibold leading-tight text-brand-navy sm:text-[2.6rem]" data-id="element-274" data-mp="3rzl0eszacqmf">
              A community built around faith, friendship, and purpose
            </h2>
            <DoodleUnderline className="mt-3 h-3 w-44" color="var(--bcm-pink)" data-id="element-275" data-mp="5qtiob5tystw" />
            <p className="mt-6 max-w-xl font-sans text-[17px] leading-relaxed text-ink" data-id="element-276" data-mp="22mr15jvq5whx">
              BCM stands for Baptist Collegiate Ministries, but the community is not exclusively
              Baptist. Students come from different denominations, religious backgrounds, schools,
              and life experiences. Whether you have followed Jesus for years, have questions about
              faith, or are simply looking for community, you are welcome to visit.
            </p>
            <ButtonLink to="/about" variant="primary" className="mt-7" data-id="element-277" data-mp="24hv1pgza44ew">
              Learn More About BCM
            </ButtonLink>
          </Reveal>

          {/* Two overlapping photo cards drifting at different speeds, with a
              hand-drawn shape floating behind them. */}
          <Reveal x={16} delay={0.1} className="relative" data-id="element-278" data-mp="2s8ifgivvlo9d">
            <DoodleCircle className="pointer-events-none absolute -left-6 top-6 h-28 w-56 opacity-70" color="var(--bcm-light-blue)" data-id="element-279" data-mp="2n95q9rhj853m" />
            <div className="relative grid grid-cols-2 gap-4" data-id="element-280" data-mp="3196pl2i5f4gz">
              <FloatingPhoto range={5} duration={6.5} data-id="element-281" data-mp="2x84rwq3vr0h4">
                <PhotoFrame photo={galleryPhotos[0]} ratio="aspect-[3/4]" rotate="-rotate-2" className="transition-transform duration-300 hover:rotate-0" data-id="element-282" data-mp="2x5ij6n596exb" />
              </FloatingPhoto>
              <FloatingPhoto range={7} duration={8} delay={1.1} className="mt-10" data-id="element-283" data-mp="36uo2vkn5s79n">
                <PhotoFrame photo={galleryPhotos[1]} ratio="aspect-[3/4]" rotate="rotate-2" className="transition-transform duration-300 hover:rotate-0" data-id="element-284" data-mp="3bspk0010xwih" />
              </FloatingPhoto>
            </div>
          </Reveal>
        </div>

        <ul className="mt-14 grid gap-8 sm:grid-cols-2 sm:gap-x-10 lg:grid-cols-4" data-id="element-285" data-mp="2o6apqv9l7z4e">
          {activities.map((activity, index) => <Reveal key={activity.title} as="li" delay={stagger(index)} className="border-t-2 border-brand-navy pt-5" data-id="element-286" data-mp="2e6jwsy0ods6f" data-mpi={index}>
              <span aria-hidden="true" className={`block h-2.5 w-10 rounded-full ${accentBars[index % 4]}`} data-id="element-287" data-mp="3lirld989lhgx" />
              <h3 className="mt-4 font-display text-xl font-bold leading-snug text-brand-navy" data-id="element-288" data-mp="3hhplqrafr3ef">
                {activity.title}
              </h3>
              <p className="mt-2 font-sans text-[15px] leading-relaxed text-ink" data-id="element-289" data-mp="37rmily9lo92d">{activity.copy}</p>
            </Reveal>)}
        </ul>
      </Container>
    </Section>;
}